import React, { useState, useCallback, useEffect } from 'react';
import { newRoles, roles } from '../../Constants';
import useApi from '../../api/useApi';

function CreateEditUser({ handleClose, notification, action, selectedUser, refreshList }) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;

  const formModel = {
    userName: '',
    slug: '',
    email: '',
    contact: '',
    avatar: '',
    userSecret: '',
    organizationId: orgId,
    role: '0',
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [state2, updateData] = useApi();
  const [organizationData, getOrganizationData] = useApi();
  const [orgData, setOrgData] = useState([]);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  useEffect(() => {
    getOrganizationData(`/organizations`, 'GET');
  }, []);
  useEffect(() => {
    if (!organizationData.isLoading && !organizationData.isError && organizationData.data) {
      setOrgData(organizationData.data.organization);
    }
  }, [organizationData.isLoading, organizationData.isError, organizationData.data]);
  useEffect(() => {}, [formData]);
  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/user/${selectedUser}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (action === 'create') postData('/user', 'POST', formData);
    else updateData(`/user/${selectedUser}`, 'PATCH', formData);
  };

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      refreshList();
      notification('success', 'User Created Successfully');
      handleClose();
    }

    if (isError) {
      notification('error', 'Unable to Create User');
    }
  }, [isLoading, isError, data]);

  // getUser for update response
  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setFormData(state.data.user);
    }

    if (state.isError) {
      notification('error', 'Unable to fetch User Detail');
    }
  }, [state]);

  // update response
  useEffect(() => {
    if (state2.data !== null) {
      refreshList();
      notification('success', 'User Details Updated');
      handleClose();
    }
    if (state2.isError) {
      notification('error', 'Unable to update user detail');
    }
  }, [state2]);

  return (
    <div
      className="flex justify-center items-center h-full w-full z-20 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className={`bg-white w-full sm:w-2/4 px-5 pt-4 relative top-${action === 'create' ? 0 : 8} rounded-2xl`}>
        <img
          src="assets/img/Close.svg"
          className="absolute top-3 right-3 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-sm text-textBlue1 border-b p-4">
          {action === 'create' ? 'Create' : 'Edit'} a User
        </p>

        <form className="mt-6 mb-2 mx-2 md:mx-10 flex flex-wrap" onSubmit={handleSubmit}>
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="userName" className="block text-parameter w-1/3 text-sm">
              NAME
            </label> */}
            <input
              type="text"
              placeholder="UserName"
              value={formData.userName}
              name="userName"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="slug" className="block text-parameter w-1/3 text-sm">
              SHORT NAME
            </label> */}
            <input
              type="text"
              placeholder="Short Name"
              value={formData.slug}
              name="slug"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>

          <div className="mt-4 w-2.25/5 relative">
            <div className="inputLabelText px-4 py-2 focus:outline-none">
              <select
                name="role"
                value={formData.role}
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={handleInputChange}
              >
                {newRoles.map((item) => (
                  <option key={item.id} value={item.id} className="fy-4">
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            <div className="inputLabelText px-4 py-2 focus:outline-none">
              <select
                name="organizationId"
                value={formData.organizationId}
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={handleInputChange}
              >
                {orgData.map((item) => (
                  <option key={item.id} value={item.id} className="fy-4">
                    {item.organizationName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="contact" className="block text-parameter w-1/3 text-sm">
              PHONE NUMBER
            </label> */}
            <input
              placeholder="Phone Number"
              type="tel"
              value={formData.contact}
              name="contact"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            {/* <label htmlFor="role" className="block text-parameter w-1/3 text-sm">
              ROLE
            </label> */}
            <input
              placeholder="Email"
              type="email"
              value={formData.email}
              name="email"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative" />
          <div className="w-6/12 md:w-7/12" />
          <div className="w-6/12 md:w-5/12 relative -right-5 md:-right-8 mb-2 mt-4">
            {state2.isLoading || isLoading ? (
              <div className="flex text-xs">
                <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
              </div>
            ) : (
              <div className="flex text-xs">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl border focus:outline-none w-1/2 h-10 mr-3 cursor-pointer "
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl focus:outline-none w-1/2 h-10 text-white bg-btnBg cursor-pointer "
                  style={{ border: '1px solid #16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>

          {/* <div className="flex w-full items-center justify-center  mt-6 relative">
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className=" w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/4 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div> */}
        </form>
      </div>
    </div>
  );
}

export default CreateEditUser;
